const VERSION = "0.0.0";
const SDK_BID = "pns_sdk_common_modules";
var Region;
(function(Region2) {
  Region2["US_EAST"] = "US-East";
  Region2["US_EASTRED"] = "US-EastRed";
  Region2["SINGAPORE_CENTRAL"] = "Singapore-Central";
  Region2["EU_TTP"] = "EU-TTP";
  Region2["EU_TTP2"] = "EU-TTP2";
  Region2["US_TTP"] = "US-TTP";
  Region2["US_TTP2"] = "US-TTP2";
})(Region || (Region = {}));
var Mode;
(function(Mode2) {
  Mode2["PRODUCTION"] = "production";
  Mode2["DEV"] = "dev";
  Mode2["BOE"] = "boe";
})(Mode || (Mode = {}));
export {
  Mode,
  Region,
  SDK_BID,
  VERSION
};

//# sourceMappingURL=env.js.map